import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
// import { candidateViewDetailGetApi } from "../api/user";
import { Col, Row } from "react-bootstrap";

import {
  FaAddressBook,
  FaRupeeSign,
  FaWallet,
  FaCalendar,
  FaMailchimp,
  FaLocationArrow,
  FaBook,
  FaMailBulk,
  FaPhone,
  FaDownload,
} from "react-icons/fa";

function AiCompleteScreenViewData() {
  const { id } = useParams();
  const [profileDetail, setData] = useState([]);

  const [singleData, setSingleData] = useState({});
  const getSingleDetails = async () => {
    try {
      if (id) {
        // const { status, result } = await candidateViewDetailGetApi(id);
        // setData(result);
      }
    } catch (error) {
      console.log(error);
    }
  };

  useEffect(() => {
    if (id) {
      getSingleDetails();
    }
  }, []);

  let feedBackData = [
    {
      id: 1,
      interview: {
        position: "Frontend Developer",
        overallImpressionScore: 12,
        date: "2025-02-28",
        time: "3:45 PM",
        finalVerdict: "Not Recommended",
        summary:
          "This interview does not reflect serious interest or engagement from the candidate. Their responses are dismissive, vague, or outright negative, making it difficult to assess their qualifications, motivation, or suitability for the role.",
        evaluationBreakdown: {
          enthusiasmAndInterest: {
            score: 0,
            total: 20,
            points: [
              "The candidate openly states, 'I really don't,' when asked why they want to work for the company.",
              "Their response to future career plans ('Probably in some other company') indicates a lack of commitment.",
            ],
          },
          communicationSkills: {
            score: 5,
            total: 20,
            points: [
              "Responses are brief and unhelpful.",
              "Some answers lack clarity (e.g., 'What am I going to do in this role at this role?').",
              "A slight redeeming factor is that they remain polite.",
            ],
          },
          selfAwarenessAndReflection: {
            score: 2,
            total: 20,
            points: [
              "The candidate refuses to discuss their background and weaknesses.",
              "They claim to have 'no weaknesses at all,' which suggests a lack of self-awareness.",
            ],
          },
        },
        finalNote:
          "This candidate does not appear to be seriously considering the role and fails to provide meaningful responses. If this is reflective of their true attitude, they would not be a good fit for most positions.",
      },
    },
    {
      id: 2,
      interview: {
        position: "Frontend Developer",
        overallImpressionScore: 85,
        date: "2025-03-01",
        time: "10:00 AM",
        finalVerdict: "Highly Recommended",
        summary:
          "The candidate showed exceptional enthusiasm and communication. Their answers were insightful, structured, and showed deep understanding of the role.",
        evaluationBreakdown: {
          enthusiasmAndInterest: {
            score: 20,
            total: 20,
            points: [
              "Expressed strong motivation to join the company.",
              "Shared well-defined career goals aligned with the organization.",
            ],
          },
          communicationSkills: {
            score: 18,
            total: 20,
            points: [
              "Clear, concise, and confident responses.",
              "Used real-world examples to support points.",
            ],
          },
          selfAwarenessAndReflection: {
            score: 17,
            total: 20,
            points: [
              "Acknowledged personal weaknesses and how they are improving.",
              "Demonstrated strong awareness of personal growth.",
            ],
          },
        },
        finalNote:
          "This candidate is an excellent fit with high potential for growth within the company.",
      },
    },
    {
      id: 3,
      interview: {
        position: "Frontend Developer",
        overallImpressionScore: 45,
        date: "2025-03-01",
        time: "11:00 AM",
        finalVerdict: "Borderline",
        summary:
          "The candidate displayed mixed interest and struggled with expressing ideas effectively. Some responses lacked depth.",
        evaluationBreakdown: {
          enthusiasmAndInterest: {
            score: 12,
            total: 20,
            points: [
              "Expressed slight interest in the company.",
              "Career goals seemed vague.",
            ],
          },
          communicationSkills: {
            score: 16,
            total: 20,
            points: [
              "Some responses were unclear.",
              "Struggled with elaborating on technical questions.",
            ],
          },
          selfAwarenessAndReflection: {
            score: 17,
            total: 20,
            points: [
              "Demonstrated a basic understanding of their strengths.",
              "Could benefit from deeper reflection on areas for improvement.",
            ],
          },
        },
        finalNote:
          "With more preparation, this candidate could become a stronger contender.",
      },
    },
    {
      id: 4,
      interview: {
        position: "Frontend Developer",
        overallImpressionScore: 20,
        date: "2025-03-02",
        time: "2:00 PM",
        finalVerdict: "Not Recommended",
        summary:
          "The candidate appeared disengaged and uncertain throughout the interview process.",
        evaluationBreakdown: {
          enthusiasmAndInterest: {
            score: 5,
            total: 20,
            points: [
              "Gave minimal responses about their interest in the company.",
              "Unclear about long-term goals.",
            ],
          },
          communicationSkills: {
            score: 6,
            total: 20,
            points: [
              "Responses lacked structure.",
              "Repeated phrases without depth.",
            ],
          },
          selfAwarenessAndReflection: {
            score: 9,
            total: 20,
            points: [
              "Mentioned challenges but did not explain solutions.",
              "Seemed uncomfortable discussing weaknesses.",
            ],
          },
        },
        finalNote:
          "The candidate may not be ready for a client-facing development role.",
      },
    },
    {
      id: 5,
      interview: {
        position: "Frontend Developer",
        overallImpressionScore: 70,
        date: "2025-03-03",
        time: "3:30 PM",
        finalVerdict: "Recommended",
        summary:
          "The candidate communicated ideas well and showed a strong understanding of front-end concepts.",
        evaluationBreakdown: {
          enthusiasmAndInterest: {
            score: 18,
            total: 20,
            points: [
              "Genuine interest in the company’s mission.",
              "Clear career trajectory shared.",
            ],
          },
          communicationSkills: {
            score: 17,
            total: 20,
            points: [
              "Used structured examples.",
              "Answered scenario-based questions well.",
            ],
          },
          selfAwarenessAndReflection: {
            score: 15,
            total: 20,
            points: [
              "Was open about areas of growth.",
              "Identified opportunities for technical improvement.",
            ],
          },
        },
        finalNote:
          "With a bit more experience, the candidate could be a strong contributor.",
      },
    },
    {
      id: 6,
      interview: {
        position: "Frontend Developer",
        overallImpressionScore: 28,
        date: "2025-03-03",
        time: "4:00 PM",
        finalVerdict: "Not Recommended",
        summary:
          "The candidate gave unclear answers and lacked clarity in basic front-end topics.",
        evaluationBreakdown: {
          enthusiasmAndInterest: {
            score: 6,
            total: 20,
            points: [
              "Mentioned applying to several companies without preference.",
              "No strong reasoning for choosing this role.",
            ],
          },
          communicationSkills: {
            score: 10,
            total: 20,
            points: [
              "Inconsistent eye contact and flow.",
              "Did not clarify technical terms well.",
            ],
          },
          selfAwarenessAndReflection: {
            score: 12,
            total: 20,
            points: [
              "Mentioned previous issues but lacked insight on resolution.",
              "Weak self-evaluation.",
            ],
          },
        },
        finalNote:
          "Consider reapplying after strengthening communication and front-end fundamentals.",
      },
    },
    {
      id: 7,
      interview: {
        position: "Frontend Developer",
        overallImpressionScore: 90,
        date: "2025-03-04",
        time: "10:00 AM",
        finalVerdict: "Highly Recommended",
        summary:
          "The candidate demonstrated outstanding clarity, technical knowledge, and motivation throughout the interview.",
        evaluationBreakdown: {
          enthusiasmAndInterest: {
            score: 20,
            total: 20,
            points: [
              "Excited to work with the team and build impactful products.",
              "Shared career progression in line with company growth.",
            ],
          },
          communicationSkills: {
            score: 20,
            total: 20,
            points: [
              "Fluent, engaging responses.",
              "Strong storytelling and explanation skills.",
            ],
          },
          selfAwarenessAndReflection: {
            score: 18,
            total: 20,
            points: [
              "Aware of both strengths and weaknesses.",
              "Provided examples of learning from past mistakes.",
            ],
          },
        },
        finalNote: "Top-tier candidate. Strongly recommend hiring.",
      },
    },
    {
      id: 8,
      interview: {
        position: "Frontend Developer",
        overallImpressionScore: 34,
        date: "2025-03-04",
        time: "10:30 AM",
        finalVerdict: "Not Recommended",
        summary:
          "The candidate was vague in their answers and did not demonstrate enough depth in technical areas.",
        evaluationBreakdown: {
          enthusiasmAndInterest: {
            score: 8,
            total: 20,
            points: [
              "Gave very short answers to motivational questions.",
              "No real insight into their aspirations.",
            ],
          },
          communicationSkills: {
            score: 12,
            total: 20,
            points: [
              "Couldn’t elaborate on technical experience.",
              "Seemed nervous and unsure.",
            ],
          },
          selfAwarenessAndReflection: {
            score: 14,
            total: 20,
            points: [
              "Some awareness of skill gaps.",
              "Did not provide concrete improvement strategies.",
            ],
          },
        },
        finalNote:
          "Needs more technical and interview coaching before applying to such roles.",
      },
    },
    {
      id: 9,
      interview: {
        position: "Frontend Developer",
        overallImpressionScore: 63,
        date: "2025-03-05",
        time: "11:00 AM",
        finalVerdict: "Recommended",
        summary:
          "The candidate handled the interview with confidence and explained most answers well.",
        evaluationBreakdown: {
          enthusiasmAndInterest: {
            score: 15,
            total: 20,
            points: [
              "Showed curiosity and interest in team culture.",
              "Wanted to contribute to open source initiatives.",
            ],
          },
          communicationSkills: {
            score: 18,
            total: 20,
            points: [
              "Spoke clearly and to the point.",
              "Good use of real-life experience.",
            ],
          },
          selfAwarenessAndReflection: {
            score: 15,
            total: 20,
            points: ["Open to feedback.", "Knew what areas need work."],
          },
        },
        finalNote: "A dependable choice with room to grow.",
      },
    },
    {
      id: 10,
      interview: {
        position: "Frontend Developer",
        overallImpressionScore: 51,
        date: "2025-03-06",
        time: "12:00 PM",
        finalVerdict: "Borderline",
        summary:
          "The candidate had average performance with strengths in some areas and gaps in others.",
        evaluationBreakdown: {
          enthusiasmAndInterest: {
            score: 14,
            total: 20,
            points: [
              "Seems interested but not deeply invested.",
              "Unclear about long-term vision.",
            ],
          },
          communicationSkills: {
            score: 14,
            total: 20,
            points: [
              "Sometimes clear, other times vague.",
              "Struggled with answering follow-up questions.",
            ],
          },
          selfAwarenessAndReflection: {
            score: 14,
            total: 20,
            points: [
              "Mentioned needing to improve ReactJS skills.",
              "Accepts feedback well.",
            ],
          },
        },
        finalNote: "May fit well in a team with mentorship support.",
      },
    },
  ];

  useEffect(() => {
    if (id) {
      let filterData = feedBackData.filter((item, index) => {
        return item?.id == id;
      });
      setSingleData(filterData[0]);
    }
  }, [id]);

  return (
    <div style={{ marginTop: "55px", marginBottom: "50px" }}>
      <Row style={{ display: "flex", justifyContent: "center", gap: "10px" }}>
        <Col
          lg={6}
          className="p-2"
          style={{
            borderRadius: "12px",
            background: "#ffff",
            fontSize: "12px",
            boxShadow: "rgba(0, 0, 0, 0.15) 1.95px 1.95px 2.6px",
            position: "relative",
            overFlow: "hidden",
          }}
        >
          <div className="p-2">
            <h6 className="">Candidate Details</h6>
            <Row
              style={{
                borderBottom: "1px solid #ddd",
                paddingBottom: "10px",
              }}
            >
              <Col lg={4}>
                <div className="mt-1 mb-1">
                  {profileDetail?.profileDetail?.profile ? (
                    <div
                      className="border"
                      style={{
                        width: "80px",
                        height: "80px",
                        borderRadius: "50%",
                        display: "flex",
                        justifyContent: "center",
                        alignItems: "center",
                      }}
                    >
                      <img
                        src={profileDetail?.profileDetail?.profile}
                        alt="no image"
                        style={{
                          width: "70px",
                          height: "70px",
                          objectFit: "contain",
                          borderRadius: "50%",
                        }}
                      />
                    </div>
                  ) : (
                    <>null</>
                  )}
                </div>
              </Col>
              <Col
                lg={7}
                style={{
                  display: "flex",
                  justifyContent: "space-between",
                  alignItems: "center",
                }}
              >
                <div>
                  <label className="m-0">Name :</label>

                  <div>{profileDetail?.name}</div>
                </div>

                <div className="">
                  <label className="m-0">Role :</label>

                  <div>{profileDetail?.personalDetail?.jobTitle}</div>
                </div>
              </Col>
            </Row>
            <div
              className="mt-2"
              style={{ borderBottom: "1px solid #ddd", paddingBottom: "20px" }}
            >
              <div style={{ fontWeight: "600" }}>Skills</div>
              {profileDetail &&
                profileDetail?.profileDetail?.keySkills.map((item) => {
                  return (
                    <div
                      className=" mr-2 mt-2"
                      style={{
                        display: "inline-block",
                        border: "1px solid #97144D",
                        borderRadius: "12px ",
                        padding: "3px 8px",
                        color: "#97144D",
                      }}
                    >
                      {item}
                    </div>
                  );
                })}
            </div>
            <div
              className="d-flex justify-content-between mt-2"
              style={{ borderBottom: "1px solid #ddd", paddingBottom: "20px" }}
            >
              <div>
                <div style={{ display: "flex", gap: "10px" }} className="mt-1">
                  <div>
                    <FaLocationArrow />
                  </div>
                  <div>{profileDetail?.personalDetail?.city || "-"}</div>
                </div>
                <div style={{ display: "flex", gap: "10px" }} className="mt-1">
                  <div>
                    <FaBook />
                  </div>
                  <div>
                    {profileDetail?.personalDetail?.expYear ? (
                      <>
                        {profileDetail?.personalDetail?.expYear} years{" "}
                        {profileDetail?.personalDetail?.expMonth} Month
                      </>
                    ) : (
                      "-"
                    )}
                  </div>
                </div>
                <div style={{ display: "flex", gap: "10px" }} className="mt-1">
                  <div>
                    <FaWallet />
                  </div>
                  <div>
                    ₹ {profileDetail?.personalDetail?.currentLPA || "0"}
                  </div>
                </div>
              </div>
              <div style={{ borderLeft: "1px solid #f0f0f6" }}></div>

              <div>
                <div style={{ display: "flex", gap: "10px" }} className="mt-1">
                  <div>
                    <FaPhone />
                  </div>
                  {profileDetail?.phoneStatus === "verified" && (
                    <div>+91 {profileDetail?.phoneNo || "-"}</div>
                  )}
                </div>
                <div style={{ display: "flex", gap: "10px" }} className="mt-1">
                  <div>
                    <FaMailBulk />
                  </div>
                  <div>{profileDetail?.email}</div>
                </div>
                <div style={{ display: "flex", gap: "10px" }} className="mt-1">
                  <div>
                    <FaCalendar />
                  </div>
                  <div>
                    {profileDetail?.personalDetail?.noticePeriod || "-"} Notice
                    Period
                  </div>
                </div>
              </div>
            </div>

            <div
              className="p-1 pb-3 mt-3 d-flex justify-content-center"
              style={{
                borderBottom: "1px solid #ddd",
                paddingBottom: "20px",
                gap: "20px",
              }}
            >
              <div>Resume</div>
              <div onClick={() => updateStatus("Admin Resume Viewed")}>
                <a
                  href={profileDetail?.profileDetail?.resume}
                  onClick={() => updateStatus("Admin Resume Viewed")}
                >
                  <FaDownload />
                </a>
              </div>
            </div>
            <div
              className="p-1 mt-3 pb-3"
              style={{
                borderBottom: "1px solid #ddd",
                paddingBottom: "20px",
              }}
            >
              <div style={{ fontWeight: "600" }}>Employment</div>
              <div className="mt-2 row " style={{ display: "flex" }}>
                {profileDetail &&
                  profileDetail?.employmentDetails?.map((item) => {
                    return (
                      <div className="col-lg-12 mb-3">
                        <div className="row">
                          <div className="col-lg-7">
                            <div className="">
                              <span style={{ fontWeight: "600" }}>
                                Organisation:
                              </span>{" "}
                              {item?.companyName}
                            </div>
                            <div className="">
                              {" "}
                              <span style={{ fontWeight: "600" }}>
                                Role:
                              </span>{" "}
                              {item?.jobTitle}
                            </div>
                            <div className="">
                              <span style={{ fontWeight: "600" }}>Exp:</span>{" "}
                              {item?.expYear} - {item?.expMonth} yrs
                            </div>
                          </div>
                          <div className="col-lg-5">
                            <div style={{ fontWeight: "600" }}>Skills :</div>
                            <div
                              style={{
                                display: "flex",
                                flexWrap: "wrap",
                                gap: "10px",
                                fontSize: "10px",
                              }}
                            >
                              {item?.skills.map((items) => {
                                return (
                                  <div className="p-1 border rounded">
                                    {" "}
                                    {items}
                                  </div>
                                );
                              })}
                            </div>
                          </div>
                        </div>
                      </div>
                    );
                  })}

                <div>
                  {profileDetail?.employmentDetails?.length === 0 && (
                    <div className="ms-5">No Employment Details...</div>
                  )}
                </div>
              </div>
            </div>
            <div
              className="p-1 mt-3 pb-3"
              style={{
                borderBottom: "1px solid #ddd",
                paddingBottom: "20px",
              }}
            >
              <div style={{ fontWeight: "600" }}>Projects</div>
              <div className="mt-2 row " style={{ display: "flex" }}>
                {profileDetail?.projectsDetails?.map((item) => {
                  return (
                    <div className="col-lg-12 mb-3">
                      <div className="row">
                        <div className="col-lg-12">
                          <div className="">
                            <span style={{ fontWeight: "600" }}>
                              Description:
                            </span>{" "}
                            {item?.projectTitle}
                          </div>
                          <div className="">
                            {" "}
                            <span style={{ fontWeight: "600" }}>
                              Status:
                            </span>{" "}
                            {item?.projectStatus}
                          </div>
                          <div className="">
                            <span style={{ fontWeight: "600" }}>Location:</span>{" "}
                            {item?.projectLocation}
                          </div>
                          <div className="">
                            <span style={{ fontWeight: "600" }}>
                              Nature of Employment:
                            </span>{" "}
                            {item?.natureOfEmployment}
                          </div>
                        </div>
                        <div className="col-lg-12">
                          <div className="d-flex align-items-center justify-content-start">
                            <div style={{ fontWeight: "600" }}>Skills :</div>
                            <div
                              style={{
                                display: "flex",
                                flexWrap: "wrap",
                                gap: "10px",
                                fontSize: "12px",
                              }}
                            >
                              <div className="p-1"> {item?.skillsUsed}</div>
                            </div>
                          </div>
                          <div>
                            <span style={{ fontWeight: "600" }}>Role:</span>{" "}
                            {item?.role}
                          </div>
                          <div>
                            <span style={{ fontWeight: "600" }}>
                              Role Description:
                            </span>{" "}
                            {item?.roleDescription}
                          </div>
                        </div>
                      </div>
                    </div>
                  );
                })}

                <div>
                  {profileDetail?.projectsDetails?.length === 0 && (
                    <div className="ms-5">No Employment Details...</div>
                  )}
                </div>
              </div>
            </div>
          </div>
          <div
            className=""
            style={{
              position: "absolute",
              top: "0",
              right: "0",
              background: "#97144D",
              borderTopRightRadius: "12px",
              borderBottomLeftRadius: "12px",
              padding: "8px 15px",
              color: "white",
            }}
          >
            {profileDetail?.userCategory ? profileDetail?.userCategory : "NA"}
          </div>
        </Col>

        <Col
          lg={5}
          className="p-3 "
          style={{
            borderRadius: "12px",
            background: "#ffff",
            fontSize: "12px",
            boxShadow: "rgba(0, 0, 0, 0.15) 1.95px 1.95px 2.6px",
            Position: "relative",
            overFlow: "hidden",
          }}
        >
          <div>
            <div
              style={{
                fontSize: "22px",
                fontWeight: "600",
                textAlign: "center",
                lineHeight: "40px",
              }}
            >
              <span style={{ color: "#96144d", fontSize: "30px" }}> F</span>
              eedback on the Interview-
              <div>
                <span
                  style={{
                    color: "#96144d",
                    fontSize: "30px",
                    paddingBottom: "20px",
                  }}
                >
                  {singleData?.interview?.position.at(0)}
                </span>
                {singleData?.interview?.position.slice(1)}
              </div>
            </div>

            <div className="mt-3 d-flex justify-content-between align-items-center">
              <div>
                <span style={{ fontWeight: "600" }}>
                  <span style={{ paddingRight: "5px" }}>
                    <i class="fa-solid fa-star"></i>
                  </span>
                  overallImpressionScore :{" "}
                  <span
                    style={{
                      fontWeight: "600",
                      fontSize: "24px",
                      color: "#96144d",
                    }}
                  >
                    {singleData?.interview?.overallImpressionScore}
                  </span>
                  / 100
                </span>
              </div>
              <div style={{ fontWeight: "600" }}>
                <span style={{ paddingRight: "5px", fontWeight: "600" }}>
                  <i class="fa-solid fa-calendar"></i>
                </span>{" "}
                {singleData?.interview?.date} - {singleData?.interview?.time}
              </div>
            </div>

            <div
              className="mt-3 mb-2"
              style={{ fontSize: "13px", lineHeight: "26px" }}
            >
              {singleData?.interview?.summary}
            </div>
          </div>

          <div className="mt-3 mb-2">
            <span style={{ fontWeight: "600", fontSize: "20px" }}>
              Breakdown of Evaluation :{" "}
            </span>
          </div>

          <div className="mt-2">
            {" "}
            <span style={{ fontSize: "15px", fontWeight: "600" }}>
              1. Enthusiasm And Interest :{" "}
              <span style={{ color: "#96144d", fontSize: "20px" }}>
                {
                  singleData?.interview?.evaluationBreakdown
                    ?.enthusiasmAndInterest?.score
                }
                /
                {
                  singleData?.interview?.evaluationBreakdown
                    ?.enthusiasmAndInterest?.total
                }{" "}
              </span>
            </span>
          </div>

          <div style={{ paddingLeft: "10px" }} className="mt-2 mb-2">
            {singleData?.interview?.evaluationBreakdown?.enthusiasmAndInterest?.points?.map(
              (item, index) => {
                return (
                  <div
                    className="mt-2 mb-2"
                    style={{
                      color: "#555a75",
                      fontWeight: "500",
                      fontSize: "12px",
                    }}
                  >
                    <span>{index + 1}. </span> {item}
                  </div>
                );
              }
            )}
          </div>

          <div className="mt-2">
            {" "}
            <span style={{ fontSize: "15px", fontWeight: "600" }}>
              2. Communication Skills :{" "}
              <span style={{ color: "#96144d", fontSize: "20px" }}>
                {
                  singleData?.interview?.evaluationBreakdown
                    ?.communicationSkills?.score
                }
                /
                {
                  singleData?.interview?.evaluationBreakdown
                    ?.communicationSkills?.total
                }{" "}
              </span>
            </span>
          </div>

          <div style={{ paddingLeft: "10px" }} className="mt-2 mb-2">
            {singleData?.interview?.evaluationBreakdown?.communicationSkills?.points?.map(
              (item, index) => {
                return (
                  <div
                    className="mt-2 mb-2"
                    style={{
                      color: "#555a75",
                      fontWeight: "500",
                      fontSize: "12px",
                    }}
                  >
                    <span>{index + 1}. </span> {item}
                  </div>
                );
              }
            )}
          </div>

          <div className="mt-2">
            {" "}
            <span style={{ fontSize: "15px", fontWeight: "600" }}>
              3. SelfAwareness And Reflection :{" "}
              <span style={{ color: "#96144d", fontSize: "20px" }}>
                {
                  singleData?.interview?.evaluationBreakdown
                    ?.selfAwarenessAndReflection?.score
                }
                /
                {
                  singleData?.interview?.evaluationBreakdown
                    ?.selfAwarenessAndReflection?.total
                }{" "}
              </span>
            </span>
          </div>

          <div style={{ paddingLeft: "10px" }} className="mt-2 mb-2">
            {singleData?.interview?.evaluationBreakdown?.selfAwarenessAndReflection?.points?.map(
              (item, index) => {
                return (
                  <div
                    className="mt-2 mb-2"
                    style={{
                      color: "#555a75",
                      fontWeight: "500",
                      fontSize: "12px",
                    }}
                  >
                    <span>{index + 1}. </span> {item}
                  </div>
                );
              }
            )}
          </div>

          <div style={{ fontWeight: "600", fontSize: "16px" }} className="mt-3">
            Final Veridict :
          </div>

          <div
            style={{
              color: "#555a75",
              fontWeight: "500",
              fontSize: "12px",
              paddingLeft: "20px",
              paddingTop: "10px",
            }}
          >
            {singleData?.interview?.finalNote}
          </div>
          {/* <div className="mt-3">
            <div>
              <span style={{ paddingRight: '5px' }}>
                <i class="fa-solid fa-desktop"></i>
              </span>
              {singleData?.interview?.position}
            </div>
          </div> */}
        </Col>
      </Row>
    </div>
  );
}

export default AiCompleteScreenViewData;
